export const paymentGateway = {
  AlfaBankRu: 'AlfaBankRu',
  CloudPayments: 'CloudPayments',
  BePaid: 'BePaid'
};
export const paymentGatewayTitles = {
  [paymentGateway.AlfaBankRu]: 'Alfabank Russian',
  [paymentGateway.BePaid]: 'BePaid',
  [paymentGateway.CloudPayments]: 'Cloud Pasyments'
};
export const settings = {
  enableIosAndroidPay: 'enableIosAndroidPay',
  paymentGateway: 'paymentGateway',
  storeMapSetting: 'storeMapSetting',
  defaultLocation: 'defaultLocation',
  defaultCity: 'defaultCity',
  reportsList: 'reportsList',
  hasPoints: 'hasPoints',
  homePageCategoriesId: 'homePageCategoriesId',
  siteProductsCount: 'siteProductsCount'
};
export const settingsTitles = {
  [settings.enableIosAndroidPay]: 'Включен IOS/Android Pay',
  [settings.paymentGateway]: 'Платежный шлюз',
  [settings.storeMapSetting]: 'Настройки карты магазина',
  [settings.defaultLocation]: 'Страна по умолчанию',
  [settings.defaultCity]: 'город по умолчанию',
  [settings.reportsList]: 'Списки отчетов',
  [settings.hasPoints]: 'Система баллов',
  [settings.homePageCategoriesId]: 'Категории главной страницы',
  [settings.siteProductsCount]: 'Кол-во продуктов на сайте'
};